( function() {
	const filterSearches = document.querySelectorAll( '.facility-filters__single-search input, .find-support-large__single-search input' );
	if( !filterSearches.length ) { return; }

	const filterGroups = document.querySelectorAll( '.facility-filters__single-options, .find-support-large__insurances-modal-list' );
	if( !filterGroups.length ) { return; }

	const HIDE_ITEM = 'hide-item';

	Array.from( filterSearches ).forEach( input => {
		input.addEventListener( 'input', searchGroup );
		searchGroup.apply( input, [{ target: input }] );
	} );

	function searchGroup( e ) {
		const id = e.target.getAttribute( 'aria-controls' );
		const group = Array.from( filterGroups ).find( group => group.id === id );
		const query = e.target.value.trim().toLowerCase() || '';

		Array.from( group.querySelectorAll( '.check-custom, .check-insurance' ) ).forEach( ele => {

			if( query.length === 0 || ele.textContent.toLowerCase().includes( query ) ) {
				ele.classList.remove( HIDE_ITEM );
			} else {
				ele.classList.add( HIDE_ITEM );
			}
		} );
	}
} )();